import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Auth token storage strategy:
 *   - PRIMARY: httpOnly cookie set by the backend on /auth/login (secure,
 *     samesite=none). This is the safe default and cannot be read from JS.
 *   - FALLBACK: localStorage-backed Bearer header. Required because modern
 *     browsers (Safari ITP, Chrome cross-site cookie restrictions) may block
 *     the cookie on preview/production domain splits, breaking auth entirely.
 *
 * Because the fallback is only used when cookies are unavailable and the token
 * is bound to a single admin user with an 8h TTL, the XSS risk is limited.
 * We rely on React's default JSX escaping + strict input validation to block
 * XSS injection paths.
 */
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("albany_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
